/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Permission } from '../common/models/Permissions';
import { clearAuthData, getJwtPayload } from './AuthUtils';

export function userHasSinglePermission(permission: Permission): boolean {
  // @ts-ignore
  const USER_PERMISSIONS: Array<Permission> = getJwtPayload().UserPermissions;

  if (!USER_PERMISSIONS || USER_PERMISSIONS.length === 0) clearAuthData();

  const ans = USER_PERMISSIONS.findIndex((p) => p === Permission.GlobalAdministrator);
  if (ans !== -1) return true;

  const res = USER_PERMISSIONS.findIndex((p) => p === permission);
  return res !== -1;
}

export function userHasAnyPermission(Allowed: Array<Permission>): boolean {
  // @ts-ignore
  const USER_PERMISSIONS: Array<Permission> = getJwtPayload().UserPermissions;

  if (!USER_PERMISSIONS || USER_PERMISSIONS.length === 0) clearAuthData();

  const ans = USER_PERMISSIONS.findIndex((p) => p === Permission.GlobalAdministrator);
  if (ans !== -1) return true;

  for (let i = 0; i < Allowed.length; i++) {
    const a = Allowed[i];
    const res = USER_PERMISSIONS.findIndex((p) => p === a);
    if (res !== -1) return true;
  }
  return false;
}

export function userHasAllPermissions(Allowed: Array<Permission>): boolean {
  // @ts-ignore
  const USER_PERMISSIONS: Array<Permission> = getJwtPayload().UserPermissions;

  if (!USER_PERMISSIONS || USER_PERMISSIONS.length === 0) clearAuthData();

  const ans = USER_PERMISSIONS.findIndex((p) => p === Permission.GlobalAdministrator);
  if (ans !== -1) return true;

  for (let i = 0; i < Allowed.length; i++) {
    const a = Allowed[i];
    const res = USER_PERMISSIONS.findIndex((p) => p === a);
    if (res === -1) return false;
  }
  return true;
}

export function companyHasSinglePermission(permission: Permission): boolean {
  // @ts-ignore
  const COMPANY_PERMISSIONS: Array<Permission> = getJwtPayload().CustomerPermissions;

  if (!COMPANY_PERMISSIONS || COMPANY_PERMISSIONS.length === 0) clearAuthData();

  const res = COMPANY_PERMISSIONS.findIndex((p) => p === permission);
  return res !== -1;
}

export function companyHasAnyPermission(Allowed: Array<Permission>): boolean {
  // @ts-ignore
  const COMPANY_PERMISSIONS: Array<Permission> = getJwtPayload().CustomerPermissions;

  if (!COMPANY_PERMISSIONS || COMPANY_PERMISSIONS.length === 0) clearAuthData();

  for (let i = 0; i < Allowed.length; i++) {
    const a = Allowed[i];
    const res = COMPANY_PERMISSIONS.findIndex((p) => p === a);
    if (res !== -1) return true;
  }
  return false;
}

export function companyHasAllPermissions(Allowed: Array<Permission>): boolean {
  // @ts-ignore
  const COMPANY_PERMISSIONS: Array<Permission> = getJwtPayload().CustomerPermissions;

  if (!COMPANY_PERMISSIONS || COMPANY_PERMISSIONS.length === 0) clearAuthData();

  for (let i = 0; i < Allowed.length; i++) {
    const a = Allowed[i];
    const res = COMPANY_PERMISSIONS.findIndex((p) => p === a);
    if (res === -1) return false;
  }
  return true;
}
